import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function getToken(data) {
  return request({
    url: `${v2Host}/auth`,
    method: 'post',
    data: data
  })
}

export function getUserInfo(token) {
  return request({
    url: `${v2Host}/me`,
    method: 'get'
  })
}

export function updateProfile(data) {
  return request({
    url: `${v2Host}/profile/update`,
    method: 'post',
    data: data
  })
}


